import Zones from "@/components/Zones/Zones";

const PowerZonesPage = () => {
  return <Zones type="power" />;
};

export default PowerZonesPage;
